import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import SvgUsaFlagRoundIcon from "@shared/assets/icons/UsaFlagRoundIcon";
import { l } from "@shared/locales/i18n";

import * as styles from "./DeliveryCountry.styles";

const DeliveryCountry = () => {
  const { t } = useTranslation();

  return (
    <div css={styles.wrapper}>
      <div css={styles.flagIconWrapper}>
        <SvgUsaFlagRoundIcon css={styles.flagIcon} aria-hidden />
      </div>
      <Typography variant="callout" colorIntensity="bold" isMarginless>
        {t(l.sharedCommon.deliveryCountryUS)}
      </Typography>
    </div>
  );
};

export { DeliveryCountry };
